"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";

import { SIDEBAR_MENU } from "../model/menu";

interface SidebarNavProps {
  onNavigate?: () => void;
}

export const SidebarNav = ({ onNavigate }: SidebarNavProps) => {
  const pathname = usePathname();

  return (
    <nav className='flex flex-col gap-1 p-4'>
      {SIDEBAR_MENU.map(({ name, href, icon: Icon }) => {
        const isActive = pathname === href || pathname.startsWith(`${href}/`);
        return (
          <Link
            key={href}
            href={href}
            onClick={onNavigate}
            className={`flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium transition-colors ${
              isActive
                ? "bg-primary text-primary-foreground"
                : "text-muted-foreground hover:bg-muted hover:text-foreground"
            }`}
          >
            <Icon className='size-5' />
            {name}
          </Link>
        );
      })}
    </nav>
  );
};
